import { Outlet } from 'react-router-dom'
import Twelvethgrade_k12_subjects from './twelvethgrade_k12_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Twelvethgrade_k12 = ( ) => {
 
  return (
    <>
   
   <TopNavbar />
  <Twelvethgrade_k12_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Twelvethgrade_k12;